const DEFAULT_OPTIONS = {
  size: 48,
  borderSize: 6,
  borderColor: 'rgba(106,122,255,0.2)',
  borderColorHover: '#6a7aff',
  backgroundColor: '#00dbad',
  markerTextClass: 'map__marker-text',
  text: 'P'
};

CircleMarker.prototype = new google.maps.OverlayView();

/**
 * Initializer
 *
 * @param {Number} latitude - Latitude location.
 * @param {Number} longitude - Longitude location.
 * @param {String} link - A link url.
 * @param {String} image - An image url.
 * @param {Object} map - The Google map object.
 * @param {Object} options - Configuration options, defaults to `DEFAULT_OPTIONS`.
 * */
function CircleMarker(latitude, longitude, link, image, map, options = {}) {
  this.latitude = latitude;
  this.longitude = longitude;
  this.link = link;
  this.image = image;
  this.map = map;
  this.options = {...DEFAULT_OPTIONS, ...options};

  this.div = null;
  this.mouseoverListener = null;
  this.mouseoutListener = null;

  this.setMap(map);
}

/**
 * Override methods for create custom overlay (onAdd, onRemove, draw).
 * For more information: https://developers.google.com/maps/documentation/javascript/customoverlays
 * */
CircleMarker.prototype.onAdd = function() {
  const div = document.createElement('div');
  const a = document.createElement('a');
  const img = document.createElement('img');

  const circleSize = `${this.options.size}px`;
  const borderSize = `${this.options.borderSize}px`;
  const linkSize = `${this.options.size - (this.options.borderSize * 2)}px`;

  div.style.position = 'absolute';
  div.style.width = circleSize;
  div.style.height = circleSize;
  div.style.borderStyle = 'solid';
  div.style.borderWidth = borderSize;
  div.style.borderColor = this.options.borderColor;
  div.style.borderRadius = '50%';
  div.style.boxSizing = 'border-box';

  if (!this.image) {
    div.style.backgroundColor = this.options.backgroundColor;
    div.innerHTML = `<span class='${this.options.markerTextClass}'>${this.options.text}</span>`;
  }

  a.href = this.link;
  a.style.position = 'absolute';
  a.style.width = linkSize;
  a.style.height = linkSize;
  a.style.borderRadius = '50%';

  img.src = this.image;
  img.style.width = '100%';
  img.style.width = '100%';
  img.style.borderRadius = '50%';

  a.appendChild(img);
  div.appendChild(a);

  this.div = div;
  this.getPanes().overlayImage.appendChild(div);

  this.mouseoverListener = google.maps.event.addDomListener(div, 'mouseover', () => {
    div.style.borderColor = this.options.borderColorHover;
  });

  this.mouseoutListener = google.maps.event.addDomListener(div, 'mouseout', () => {
    div.style.borderColor = this.options.borderColor;
  });
};

CircleMarker.prototype.onRemove = function() {
  google.maps.event.removeListener(this.mouseoverListener);
  google.maps.event.removeListener(this.mouseoutListener);

  this.div.parentNode.removeChild(this.div);
  this.div = null;
};

CircleMarker.prototype.draw = function() {
  const photographerLatLng = new google.maps.LatLng(this.latitude, this.longitude);
  const point = this.getProjection().fromLatLngToDivPixel(photographerLatLng);

  const div = this.div;

  div.style.top = point.y + 'px';
  div.style.left = point.x + 'px';
};

export default CircleMarker;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/map/markers/CircleMarker.js